import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import MenuLinks from './components/MenuLinks';

import {
  Divider,
  VertContainer,
  VertTokens,
  VertTypography,
} from '@vertem-core/vertice-ds';
import { useMediaQuery } from 'react-responsive';
import { Link } from 'react-router-dom';
import parse from 'html-react-parser';
import ModalPointsCash from 'components/Modal/ModalPointsCash';

export const FooterWrapper = ({ children }) => {
  return (
    <VertContainer
      fluid={true}
      className="GenericFooter footer-background"
      spacingX="regular"
      spacingY="small"
    >
      <VertContainer>{children}</VertContainer>
    </VertContainer>
  );
};
FooterWrapper.propTypes = {
  children: PropTypes.node,
};

const GenericFooter = ({ items, disclaimer, label, children }) => {
  const isLargeScreen = useMediaQuery({ minWidth: 769 });
  const footerSufixClassName = isLargeScreen ? '-desktop' : '-mobile';
  const [openModalPointsCash, setOpenModalPointsCash] = useState(false);

  const { designTokens } = useContext(VertTokens);
  const { 'logotipo-footer': Logotipo } = designTokens;

  return (
    <FooterWrapper>
      <div className={`footer-header footer-header${footerSufixClassName}`}>
        {Logotipo ? (
          <div key={'logotipo-footer'} className="MenuLinks-item">
            <Link to={'/'} className="MenuLinks-item-link">
              <img
                className="MenuLinks-item-image"
                src={Logotipo}
                alt={process.env.REACT_APP_TITLE}
              />
            </Link>
          </div>
        ) : (
          ''
        )}
        <MenuLinks
          links={items}
          setOpenModal={() => setOpenModalPointsCash(true)}
        />
      </div>
      {(() => {
        if (children) return children;
        return (
          <div
            className={`footer-disclaimer footer-disclaimer${footerSufixClassName}`}
          >
            <Divider className="footer-divider" />
            <VertTypography.Paragraph className="font-w-400 ">
              {parse(`
                <span class="footer-typography">
              
              ${label}
                <span/>
              `)}
            </VertTypography.Paragraph>

            <span className="footer-typography">{disclaimer}</span>
          </div>
        );
      })()}
      <ModalPointsCash
        open={openModalPointsCash}
        handleClose={() => setOpenModalPointsCash(false)}
      />
    </FooterWrapper>
  );
};

GenericFooter.propTypes = {
  items: PropTypes.array,
  label: PropTypes.string,
  disclaimer: PropTypes.string,
  isLoading: PropTypes.bool,
  error: PropTypes.object,
  children: PropTypes.node,
};


export default GenericFooter;
